import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/business/Footer/Footer';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "reactstrap";
import FAQBg from "../../images/backgrounds/faq_bg_image.webp";
const AlgemeneVoorwaarden = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    return (
        <Fragment>
            <Header />
            <main className="page_content">
                <PageTitle
                    pageTitle={'Algemene Voorwaarden'}
                    bgImage={FAQBg}
                />
                <section className="intro_about_section section_space">
                    <div className="container">
                        <div className="heading_block mb-0">
                            <div className="row justify-content-lg-between">
                                <div className="col-lg-4">
                                    <h2 className="heading_text mb-0">
                                        Algemene Voorwaarden
                                    </h2>
                                </div>
                                <div className="col-lg-6">
                                    <p className="heading_description mb-0">
                                        Welkom bij de Algemene Voorwaarden van Praeventor. In dit document vindt u de afspraken, voorwaarden en rechten die van toepassing zijn op het gebruik van onze diensten en producten. Onze Algemene Voorwaarden zijn opgesteld om duidelijkheid te bieden over onze verantwoordelijkheden en die van u als klant, en om een veilige, transparante samenwerking te waarborgen. We raden u aan om deze voorwaarden zorgvuldig door te nemen. Heeft u vragen? Neem gerust contact met ons op – we helpen u graag verder.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "200px"}}>
                            <div>
                                <div className="faq_accordion accordion" id="faq_accordion">
                                    <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="1">
                                                1. Algemene Informatie
                                            </AccordionHeader>
                                            <AccordionBody accordionId="1" className='acc_body'>
                                                <p>
                                                    Praeventor Security Technology, gevestigd in Utrecht, is een cybersecurity-dienstverlener die IT-beveiligingsdiensten, consultancy en opleidingen aanbiedt aan bedrijven van verschillende omvang. Deze Algemene Voorwaarden zijn van toepassing op alle diensten en producten die door Praeventor worden aangeboden.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="2">
                                                2. Definities
                                            </AccordionHeader>
                                            <AccordionBody accordionId="2" className='acc_body'>
                                                <p>
                                                    In deze voorwaarden wordt verstaan onder:
                                                </p>
                                                <p>
                                                    - Klant: de natuurlijke persoon of rechtspersoon die een overeenkomst aangaat met Praeventor.
                                                </p>
                                                <p>
                                                    - Diensten: alle cybersecurity- en IT-gerelateerde diensten die door Praeventor aan de klant worden geleverd.
                                                </p>
                                                <p>
                                                    - Overeenkomst: de schriftelijke afspraak tussen Praeventor en de klant met betrekking tot het leveren van diensten.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="3">
                                                3. Toepasselijkheid
                                            </AccordionHeader>
                                            <AccordionBody accordionId="3" className='acc_body'>
                                                <p>
                                                    Deze Algemene Voorwaarden zijn van toepassing op alle aanbiedingen, offertes, overeenkomsten en leveringen van diensten door Praeventor, tenzij schriftelijk anders overeengekomen.
                                                    </p>
                                                <p>
                                                    Afwijkingen van deze voorwaarden zijn alleen geldig indien schriftelijk overeengekomen.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="4">
                                                4. Diensten en Verantwoordelijkheden
                                            </AccordionHeader>
                                            <AccordionBody accordionId="4" className='acc_body'>
                                                <p>
                                                    - Praeventor biedt diverse cybersecurity-diensten aan, zoals penetratietests, risicobeoordelingen, monitoring, en trainingen. De specifieke aard en reikwijdte van de diensten worden vastgelegd in de overeenkomst met de klant.
                                                </p>
                                                <p>
                                                    - Praeventor zal de diensten naar beste kunnen uitvoeren, maar geeft geen garanties voor specifieke resultaten, gezien de dynamische aard van cybersecurity.
                                                </p>
                                                <p>
                                                    - De klant is zelf verantwoordelijk voor de interne implementatie en naleving van beveiligingsaanbevelingen die Praeventor verstrekt, tenzij anders overeengekomen.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="5">
                                                5. Vertrouwelijkheid en Gegevensbescherming
                                            </AccordionHeader>
                                            <AccordionBody accordionId="5" className='acc_body'>
                                                <p>
                                                    - Beide partijen verplichten zich tot geheimhouding van alle vertrouwelijke informatie die zij in het kader van de overeenkomst verkrijgen.
                                                </p>
                                                <p>
                                                    - Praeventor zal passende technische en organisatorische maatregelen treffen om klantdata te beschermen en voldoet aan de relevante privacywetgeving, waaronder de AVG (Algemene Verordening Gegevensbescherming).
                                                </p>
                                                <p>
                                                    - De klant is zelf verantwoordelijk voor het verkrijgen van toestemming voor het verwerken van persoonsgegevens die met Praeventor gedeeld worden in het kader van de dienstverlening.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="6">
                                                6. Aansprakelijkheid
                                            </AccordionHeader>
                                            <AccordionBody accordionId="6" className='acc_body'>
                                                <p>
                                                    - Praeventor is niet aansprakelijk voor indirecte schade, waaronder maar niet beperkt tot gevolgschade, gederfde winst of gemiste besparingen.
                                                </p>
                                                <p>
                                                    - De aansprakelijkheid van Praeventor voor directe schade is in alle gevallen beperkt tot maximaal het bedrag dat in rekening is gebracht voor de betreffende dienstverlening.
                                                </p>
                                                <p>
                                                    - De klant vrijwaart Praeventor voor alle aanspraken van derden die voortvloeien uit of verband houden met de uitvoering van de overeenkomst, tenzij sprake is van opzet of grove nalatigheid door Praeventor
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="7">
                                                7. Betaling en Tarieven
                                            </AccordionHeader>
                                            <AccordionBody accordionId="7" className='acc_body'>
                                                <p>
                                                    - De klant dient de facturen van Praeventor te betalen binnen de op de factuur vermelde betalingstermijn.
                                                </p>
                                                <p>
                                                    - Bij niet-tijdige betaling is de klant van rechtswege in verzuim en is hij verplicht om wettelijke rente en incassokosten te betalen.
                                                </p>
                                                <p>
                                                    - Praeventor behoudt zich het recht voor om tarieven periodiek te herzien en zal de klant hierover tijdig informeren.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="8">
                                                8. Intellectueel Eigendom
                                            </AccordionHeader>
                                            <AccordionBody accordionId="8" className='acc_body'>
                                                <p>
                                                    - Alle intellectuele eigendomsrechten met betrekking tot door Praeventor geleverde diensten, analyses, rapporten en documentatie blijven eigendom van Praeventor, tenzij schriftelijk anders overeengekomen.
                                                </p>
                                                <p>
                                                    - De klant krijgt een beperkt, niet-overdraagbaar recht om de rapporten en adviezen van Praeventor intern te gebruiken.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="9">
                                                9. Overmacht
                                            </AccordionHeader>
                                            <AccordionBody accordionId="9" className='acc_body'>
                                                <p>
                                                    Praeventor is niet aansprakelijk voor het niet nakomen van haar verplichtingen indien dit het gevolg is van overmacht, waaronder wordt verstaan: storingen in het internet, datanetwerk of telecominfrastructuur, stroomstoringen, stakingen, ziekte van personeel, overheidsmaatregelen en andere onvoorziene omstandigheden.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="10">
                                                10. Duur en Beëindiging van de Overeenkomst
                                            </AccordionHeader>
                                            <AccordionBody accordionId="10" className='acc_body'>
                                                <p>
                                                    De overeenkomst wordt aangegaan voor de duur die is afgesproken in de overeenkomst, tenzij anders schriftelijk overeengekomen.
                                                </p>
                                                <p>
                                                    Beide partijen kunnen de overeenkomst tussentijds beëindigen indien de andere partij toerekenbaar tekortschiet in de nakoming van de verplichtingen, en deze tekortkoming niet binnen een redelijke termijn wordt hersteld.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                        <AccordionItem className="accordion-item">
                                            <AccordionHeader targetId="11">
                                                11. Toepasselijk Recht en Geschillenbeslechting
                                            </AccordionHeader>
                                            <AccordionBody accordionId="11" className='acc_body'>
                                                <p>
                                                    Op alle rechtsverhoudingen tussen Praeventor en de klant is het Nederlands recht van toepassing.
                                                </p>
                                                <p>
                                                    Geschillen tussen Praeventor en de klant zullen bij voorkeur in onderling overleg worden opgelost. Indien dit niet mogelijk is, worden geschillen voorgelegd aan de bevoegde rechter te Utrecht.
                                                </p>
                                            </AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AlgemeneVoorwaarden;
